import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    ACA_DASHBOARD_COACH,
    ACA_DASHBOARD_PLAYER,
    ACA_DASHBOARD_BOWLER,
    ACA_DASHBOARD_BATWK,
    ACA_DASHBOARD_ALLR
} from '../constants/ActionTypes';

import {
    acaDashboardCoachSuccess,
    acaDashboardCoachError,
    acaDashboardPlayerSuccess,
    acaDashboardPlayerError,
    acaDashboardBowlerSuccess,
    acaDashboardBowlerError,
    acaDashboardBatwkSuccess,
    acaDashboardBatwkError,
    acaDashboardAllrSuccess,
    acaDashboardAllrError
} from "../actions/DashboardAction";

import { userSignOut } from '../actions/Auth'

import { acaDashboardCoachApi, acaDashboardPlayerApi, acaDashboardBowlerApi, acaDashboardBatwkApi, acaDashboardAllrApi } from "../api/DashboardApi"


function* acaDashboardCoachRequest({ payload }) {
    try {
        const { sessionToken } = payload
        const dashboardResponse = yield call(acaDashboardCoachApi, sessionToken)
        if (dashboardResponse.code) {
            if (dashboardResponse.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(acaDashboardCoachError(dashboardResponse));
            }
        } else {
            yield put(acaDashboardCoachSuccess(dashboardResponse));
        }
    } catch (error) {
        console.log("acaDashboardCoachError error : " + error)
        yield put(acaDashboardCoachError(error))
    }
}

function* acaDashboardPlayerRequest({ payload }) {
    try {
        const { sessionToken } = payload
        const dashboardResponse = yield call(acaDashboardPlayerApi, sessionToken)
        if (dashboardResponse.code) {
            yield put(acaDashboardPlayerError(dashboardResponse));
        } else {
            yield put(acaDashboardPlayerSuccess(dashboardResponse));
        }
    } catch (error) {
        console.log("acaDashboardPlayerError error : " + error)
        yield put(acaDashboardPlayerError(error))
    }
}

function* acaDashboardBowlerRequest({ payload }) {
    try {
        const { sessionToken } = payload
        const dashboardResponse = yield call(acaDashboardBowlerApi, sessionToken)
        if (dashboardResponse.code) {
            yield put(acaDashboardBowlerError(dashboardResponse));
        } else {
            yield put(acaDashboardBowlerSuccess(dashboardResponse));
        }
    } catch (error) {
        console.log("acaDashboardBowlerError error : " + error)
        yield put(acaDashboardBowlerError(error))
    }
}

function* acaDashboardBatwkRequest({ payload }) {
    try {
        const { sessionToken } = payload
        const dashboardResponse = yield call(acaDashboardBatwkApi, sessionToken)
        if (dashboardResponse.code) {
            yield put(acaDashboardBatwkError(dashboardResponse));
        } else {
            yield put(acaDashboardBatwkSuccess(dashboardResponse));
        }
    } catch (error) {
        console.log("acaDashboardBatwkError error : " + error)
        yield put(acaDashboardBatwkError(error))
    }
}

function* acaDashboardAllrRequest({ payload }) {
    try {
        const { sessionToken } = payload
        const dashboardResponse = yield call(acaDashboardAllrApi, sessionToken)
        if (dashboardResponse.code) {
            yield put(acaDashboardAllrError(dashboardResponse));
        } else {
            yield put(acaDashboardAllrSuccess(dashboardResponse));
        }
    } catch (error) {
        console.log("acaDashboardAllrError error : " + error)
        yield put(acaDashboardAllrError(error))
    }
}



export function* acaDashboardCoach() {
    yield takeEvery(ACA_DASHBOARD_COACH, acaDashboardCoachRequest);
}

export function* acaDashboardPlayer() {
    yield takeEvery(ACA_DASHBOARD_PLAYER, acaDashboardPlayerRequest);
}

export function* acaDashboardBowler() {
    yield takeEvery(ACA_DASHBOARD_BOWLER, acaDashboardBowlerRequest);
}

export function* acaDashboardBatwk() {
    yield takeEvery(ACA_DASHBOARD_BATWK, acaDashboardBatwkRequest);
}

export function* acaDashboardAllr() {
    yield takeEvery(ACA_DASHBOARD_ALLR, acaDashboardAllrRequest);
}

export default function* rootSaga() {
    yield all([fork(acaDashboardCoach),
    fork(acaDashboardPlayer),
    fork(acaDashboardBowler),
    fork(acaDashboardBatwk),
    fork(acaDashboardAllr),
    ])
}